import React, { useContext, useEffect, useState } from 'react'
import moment from 'moment'
import styled from 'styled-components'
import PageLayout from '../../components/PageLayout'
import { RecordContext, recordData } from './RecordPage'
import { AppContext } from '../../Context'
import LabelField from '../../../common/LabelField'
import Checkbox from '../../../common/Checkbox'
import { submitRecord } from '../../services/record-services'
import { useHistory } from 'react-router'
import Stepper from '../../components/Stepper'
import { getConsentLabels } from '../../services'

const Container = styled(PageLayout)`
  .field {
    margin-bottom: 26px;
  }
  & .checkbox{
    margin-bottom: 20px
  }
`

function RecordSignature({ ...props }) {
  const { record, setRecord, steps } = useContext(RecordContext)
  const { flagRecordsUpdate, setFlagRecordsUpdate } = useContext(AppContext)
  const [condition1, setCondition1] = useState(false)
  const [condition2, setCondition2] = useState(false)
  const [error, setError] = useState('')
  const [consentLabel1, setconsentLabel1] = useState(null)
  const [consentLabel2, setconsentLabel2] = useState(null)
  const history = useHistory()

  useEffect(() => {
    const fetch = async () => {
      const labels = await getConsentLabels(['record1', 'record2'])
      setconsentLabel1(labels['consent.label.record1'])
      setconsentLabel2(labels['consent.label.record2'])
    }
    if (!consentLabel1 || !consentLabel2) {
      fetch()
    }
  }, [])

  const canSubmit = condition1 && condition2
  const submit = () => {
    setError('')
    return submitRecord(record._id, consentLabel1 + ' ' + consentLabel2, recordData)
    .then(resp => {
      if (resp && resp.errors) {
        setError('Une erreur est survenue, veuillez vérifier votre demande')
        return true
      }
      if (resp.data.submitRecord) {
        setError('')
        setRecord(resp.data.submitRecord)
        setFlagRecordsUpdate(!flagRecordsUpdate)
        history.push('/record-sent')
        return true
      } else {
        history.push('/error/404')
        return true
      }
    })
  }

  return (
    <Container
      title="4 | Je déclare sur l’honneur"
      prevLink='/attachment'
      actions={ {
        submitTxt: 'Envoyer mon dossier',
        onSubmit: submit,
        disableSubmit: !canSubmit
      } }
    >
      <Stepper steps={ steps } activeStep={ 3 }/>
      <LabelField label="Date" subLabelUnderline={ true }>
        { moment().format('DD/MM/YYYY') }
      </LabelField>
      <Checkbox checked={ condition1 } onChange={ value => setCondition1(value) }
                position="right"
      >{ consentLabel1 }</Checkbox>
      <Checkbox checked={ condition2 } onChange={ value => setCondition2(value) }
                position="right"
      >{ consentLabel2 }</Checkbox>
    </Container>
  )
}

export default RecordSignature
